import { Fragment } from 'react';
import NextLink from 'next/link';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@savvy-kit/components/breadcrumb';
import { isNil } from 'es-toolkit';

import type { ClientPortalCrumb } from './types';
import { CLIENT_PORTAL_CRUMB_LEAF_CLASS } from './constants';

type ClientPortalBreadcrumbsProps = {
  readonly crumbs: readonly ClientPortalCrumb[];
};

function ClientPortalCrumbContent({
  crumb,
  isCurrent,
}: {
  readonly crumb: ClientPortalCrumb;
  readonly isCurrent: boolean;
}) {
  if (isCurrent) {
    return (
      <BreadcrumbPage className={CLIENT_PORTAL_CRUMB_LEAF_CLASS} title={crumb.label}>
        {crumb.label}
      </BreadcrumbPage>
    );
  }
  if (isNil(crumb.href)) {
    return (
      <span className={CLIENT_PORTAL_CRUMB_LEAF_CLASS} title={crumb.label}>
        {crumb.label}
      </span>
    );
  }
  return (
    <BreadcrumbLink className="shrink-0" render={<NextLink href={crumb.href} />}>
      {crumb.label}
    </BreadcrumbLink>
  );
}

export function ClientPortalBreadcrumbs({ crumbs }: ClientPortalBreadcrumbsProps) {
  return (
    <Breadcrumb>
      <BreadcrumbList className="flex-nowrap">
        {crumbs.map((crumb, index) => (
          <Fragment key={`${crumb.label}|${crumb.href ?? ''}`}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem className="min-w-0">
              <ClientPortalCrumbContent crumb={crumb} isCurrent={index === crumbs.length - 1} />
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
